import React from 'react';
import omit from 'lodash/omit';
import GeneralMenu from '@/components/navigation/GeneralMenu';
import GeneralChart from '@/components/seo/GeneralChart';
import { DEVELOPMENT_PATH_ITEMS } from '@/constants/job-title';
import { sortByOrder } from '@/utils/common-utils';

const LEVEL_ORDER = ['初级', '中级', '高级', '资深'];
const GAP_ORDER = ['初级', '发展', '中级', '高级'];

const DevelopmentPath = (props: {
  show: boolean;
  pathData: Record<string, any>;
  stagData: Record<string, any>;
  capabilityData: Record<string, any>;
}) => {
  const { show, pathData, stagData, capabilityData } = props;

  return (
    <div
      className={`relative ${show ? 'max-h-full' : 'max-h-0 overflow-hidden'}`}
    >
      <GeneralMenu menuList={DEVELOPMENT_PATH_ITEMS} />
      <h2 className="text-xl font-semibold">
        作为求职者，如何分析这个职位的成长
      </h2>
      <GeneralChart
        id={DEVELOPMENT_PATH_ITEMS[0].id}
        title="有哪些职业成长路径？"
        tip={pathData['tip']}
      >
        {Object.entries(omit(pathData, 'tip')).map(([key, item], index) => (
          <React.Fragment key={index}>
            <h4
              className={`font-semibold mb-2 ${index == 0 ? 'mt-0' : 'mt-4'}`}
            >
              {key}
            </h4>
            <p className="mb-2">{item['总体说明'] || ''}</p>
            <ul className="list-inside !ml-2">
              {(item['成长阶段'] || []).map((item: string, index: number) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p className="mt-2">{item['适合人群'] || ''}</p>
          </React.Fragment>
        ))}
      </GeneralChart>
      <GeneralChart
        id={DEVELOPMENT_PATH_ITEMS[1].id}
        title="如何规划你的职业阶段？"
        tip={stagData['tip']}
      >
        {Object.entries(omit(stagData, 'tip'))
          .sort(sortByOrder(LEVEL_ORDER))
          .map(([key, item], index) => (
            <React.Fragment key={index}>
              <h4
                className={`font-semibold mb-2 ${index == 0 ? 'mt-0' : 'mt-4'}`}
              >
                {key}
              </h4>
              <p className="mb-2">{item['总体说明'] || ''}</p>
              <ul className="list-inside !ml-2">
                {(item['阶段建议'] || []).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </React.Fragment>
          ))}
      </GeneralChart>
      <GeneralChart
        id={DEVELOPMENT_PATH_ITEMS[2].id}
        title="你的能力发展地图"
        tip={capabilityData['tip']}
      >
        {Object.entries(omit(capabilityData, 'tip'))
          .sort(sortByOrder(GAP_ORDER))
          .map(([key, item], index) => (
            <React.Fragment key={index}>
              <h4
                className={`font-semibold mb-2 ${index == 0 ? 'mt-0' : 'mt-4'}`}
              >
                {key}
              </h4>
              <p className="mb-2">{item['能力定位说明'] || ''}</p>
              <ul className="list-inside !ml-2">
                {(item['关键能力要点'] || []).map(
                  (item: string, index: number) => (
                    <li key={index}>{item}</li>
                  ),
                )}
              </ul>
              <p className="mt-2">{item['能力目标'] || ''}</p>
            </React.Fragment>
          ))}
      </GeneralChart>
    </div>
  );
};
export default DevelopmentPath;
